import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export const Modal = ({ open, onClose, children, label, testId }) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        window.__lenis?.stop();
        document.body.dataset.modalOpen = "true";
        return () => {
            window.removeEventListener("keydown", onKey);
            window.__lenis?.start();
            delete document.body.dataset.modalOpen;
        };
    }, [open, onClose]);

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    className="fixed inset-0 z-[90] flex items-end sm:items-center justify-center p-0 sm:p-8"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    role="dialog"
                    aria-label={label}
                >
                    <div
                        className="absolute inset-0 bg-ink/60 backdrop-blur-sm"
                        onClick={onClose}
                    />
                    <motion.div
                        data-testid={testId}
                        data-lenis-prevent
                        className="relative w-full sm:max-w-2xl max-h-[88vh] overflow-y-auto bg-paper border border-line shadow-2xl"
                        initial={{ y: 80, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 60, opacity: 0 }}
                        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <button
                            onClick={onClose}
                            data-testid={`${testId}-close`}
                            aria-label="Cerrar"
                            className="absolute top-4 right-4 z-10 p-2 text-subtle hover:text-crimson transition-colors"
                        >
                            <X size={20} />
                        </button>
                        {children}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Modal;
